import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setToast } from 'core/toast';

export default function useToast() {
  const dispatch = useDispatch();
  const sendToast = useCallback(toast => dispatch(setToast(toast)), [dispatch]);
  return sendToast;
}
